/*
 * @Author: Json Chen
 * @Date: 2021-09-27 18:49:00
 * @LastEditTime: 2022-06-10 17:22:11
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelRegistration/CustomerLogin2FA/index.tsx
 */
import Configuration from '@/src/components/Configuration/Configuration';
import React from 'react';
import { Form, RadioGroup, RadioItem } from 'src/components/Antd';
import SectionWrapper from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/SectionWrapper';
import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

//hideRarePart
const Item = Form.Item;
export enum ELogin {
  OFF = 'OFF',
  ALWAYS_ON = 'ALWAYS_ON',
  UNDER_THREAD_ONLY = 'UNDER_THREAD_ONLY',
}
const Login2FA = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { setHasModified, disableEdit } = props;
  return (
    <SectionWrapper
      title={getI18n('salesChannelRegistration.index.customerLogin2FA')}
      containerClassName={css.containerClassName}>
      <Item name={'login2FA'}>
        <RadioGroup
          className={css.group}
          disabled={disableEdit}
          onChange={() => {
            setHasModified(true);
          }}>
          <RadioItem value={ELogin.OFF} className={css.radio}>
            {getI18n('salesChannelRegistration.index.off')}
          </RadioItem>
          <RadioItem value={ELogin.ALWAYS_ON} className={css.radio}>
            {getI18n('salesChannelRegistration.index.alwayson')}
          </RadioItem>
          <RadioItem value={ELogin.UNDER_THREAD_ONLY}>
            {getI18n('salesChannelRegistration.index.underthreatonly')}
          </RadioItem>
        </RadioGroup>
      </Item>
      <Configuration
        hideRarePart
        configStart={getI18n(
          'salesChannelRegistration.index.configStartCustomerlogin2FA',
        )}
      />
    </SectionWrapper>
  );
};
export default Login2FA;
